import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EvaluationState, EvaluationGroup } from './types';

const initialState: EvaluationState = {
  groups: [],
  loading: false,
  error: null,
  total: 0,
};

const evaluationSlice = createSlice({
  name: 'evaluation',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setEvaluationsData: (
      state,
      action: PayloadAction<{ data: EvaluationGroup[]; total: number }>,
    ) => {
      state.groups = action.payload.data;
      state.total = action.payload.total;
    },
    updateGroup: (state, action: PayloadAction<EvaluationGroup>) => {
      const index = state.groups.findIndex((group) => group.trace_id === action.payload.trace_id);
      if (index !== -1) {
        state.groups[index] = action.payload;
      }
    },
  },
});

export const { setLoading, setError, setEvaluationsData, updateGroup } = evaluationSlice.actions;

export default evaluationSlice.reducer;
